import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import fusoChat from "../../assets/fusoChat.svg"; 
import targetPnc from "../../assets/tagretPnc.svg";
import './FusoChatEndMessage.css';

const FusoChatEndMessage = ({ askAnotherQueryClicked, handleResetQuery, key, cycleId, message }) => {
  const { t, i18n } = useTranslation();
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  useEffect(() => {
    if (message?.showAskAnotherQueryButton === false || askAnotherQueryClicked === true) {
      setIsButtonVisible(false);
    } else {
      setIsButtonVisible(true);
    }
  }, []);

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          const addedNode = mutation.addedNodes[0];
          const isUserMessage = addedNode?.classList?.contains('userPartPnc') && 
                               !addedNode.querySelector('.questionPartPnc')?.textContent?.match(/^(Yes|No)$/);
          
          if (isUserMessage) {
            setIsButtonVisible(false);
          }
        }
      });
    });

    const chatContainer = document.querySelector('.mainChatPnc');
    if (chatContainer) {
      observer.observe(chatContainer, {
        childList: true,
        subtree: true,
      });
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div key={key || `${cycleId}-end-message`} className="fusoChatFirst mt-[16px] queryMarkPnc end-message-container">
      <img src={fusoChat} alt="FUSO" className="w-6 h-6 fusoLogoSmall" />
      <div className="bg-red-50 p-4 pncChatFirst custom-radius">
        <p className="paraMarginPnc iconLastPnc">
          <span>{t('awesomeMessage')} </span>
          <img className="targetIconPnc" src={targetPnc} alt="target icon" />
        </p>
        
        <div className={`flex gap-4 mt-2 ${isButtonVisible ? '' : 'hidden'}`}>
          <button
            className="px-4 py-2 bg-[transparent] rounded yesBtnPnc ask-another-query-btn"
            onClick={() => {
              setIsButtonVisible(false);
              handleResetQuery();
            }}
          >
            {t('askAnotherQuery')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FusoChatEndMessage;